import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row no-wrap fix full-height"
}

import AppLoading from "./common/AppLoading.vue";
import InfoBlock from "./blocks/InfoBlock.vue";
import { computed, ref } from "vue";
import { injector } from "@/services";
import { APP_LAYOUT_SERVICE_INJECTION_TOKEN } from "../constants";
import { ELayoutRegisteredItems } from "../types";
import { useLayoutBaseFeature } from "../composables";
import { useUIKit } from "draivn-ui-kit";
import { CONFIG_RENDER_SERVICE_INJECTION_KEY } from "@/constants";
import { LOGO_BLOCK_RENDER_FEATURE_KEY } from "../constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainComponent',
  setup(__props) {

const configRenderService = injector.injectFromRoot(
  CONFIG_RENDER_SERVICE_INJECTION_KEY
);
const info = configRenderService.getConfig<{
  mobileUrl: string;
}>(LOGO_BLOCK_RENDER_FEATURE_KEY);

const logoUrl = `${process.env.VUE_APP_BASE_URL}${info?.mobileUrl}`;

const $uiKit = useUIKit();

$uiKit.screen.setSizes({ lg: 1160 });

const isDesktopView = computed(
  () => $uiKit.screen.width > $uiKit.screen.sizes.lg
);

const loading = ref<boolean>(false);

const layoutService = injector.injectFromRoot(
  APP_LAYOUT_SERVICE_INJECTION_TOKEN
);

const { drawerLeft, drawerLeftComponent, drawerRight, drawerRightComponent } =
  useLayoutBaseFeature($uiKit.screen.gt.md);

layoutService.registerItem(ELayoutRegisteredItems.LEFT_SIDEBAR, InfoBlock);

return (_ctx: any,_cache: any) => {
  const _component_d_header = _resolveComponent("d-header")!
  const _component_d_drawer = _resolveComponent("d-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_d_page_container = _resolveComponent("d-page-container")!
  const _component_d_layout = _resolveComponent("d-layout")!

  return (_openBlock(), _createBlock(_component_d_layout, {
    class: "drv-bg-color-n0",
    view: "hHr lpR lfr"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_d_header, { class: "onboarding-header drv-bg-color-n0 drv-p-6" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "header-logo",
            src: logoUrl,
            alt: "Logo"
          })
        ]),
        _: 1
      }),
      (isDesktopView.value)
        ? (_openBlock(), _createBlock(_component_d_drawer, {
            key: 0,
            class: "onboarding-info-drawer",
            side: "left",
            persistent: "",
            "show-if-above": "",
            behavior: "desktop",
            modelValue: _unref(drawerLeft),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(drawerLeft) ? (drawerLeft).value = $event : null)),
            breakpoint: 1161,
            width: 459
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(drawerLeftComponent)), {
                modelValue: _unref(drawerLeft),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(drawerLeft) ? (drawerLeft).value = $event : null))
              }, null, 8, ["modelValue"]))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_d_page_container, null, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createBlock(AppLoading, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_view)
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_d_drawer, {
        side: "right",
        modelValue: _unref(drawerRight),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(drawerRight) ? (drawerRight).value = $event : null)),
        width: isDesktopView.value ? 460 : _unref($uiKit).screen.width,
        overlay: !isDesktopView.value,
        behavior: "desktop"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(drawerRightComponent)), {
            modelValue: _unref(drawerRight),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(drawerRight) ? (drawerRight).value = $event : null))
          }, null, 8, ["modelValue"]))
        ]),
        _: 1
      }, 8, ["modelValue", "width", "overlay"])
    ]),
    _: 1
  }))
}
}

})